//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this  projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
	}
	//#endregion

	return {
		outerStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				height: !isMobile ? '95vh' : 'auto',
				position: 'relative',
			};
		},
		imageElementStyle: ({bgImage} = {}) => {
			return {
				position: 'absolute',
				width: '100%',
				height: '100%',
				backgroundImage: `url(${bgImage})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
			};
		},
		imageLightenerStyle: () => {
			return {
				position: 'absolute',
				width: '100%',
				height: '100%',
				backgroundColor: `rgba(255, 255, 255, 0.8)`,
			};
		},
		contentCentererStyle: () => {
			return {
				margin: `auto`,
				position: `relative`,
				padding: `0rem ${minimumMarginX}rem`,
			};
		},
		lowerContentContainerStyle: () => {
			return {
				display: 'flex',
				flexWrap: isMobile ? 'wrap' : 'unset',
			};
		},
		lowerRightContainerStyle: () => {
			return {
				display: 'felx',
				flexDirection: 'column',
				padding: `1rem 0rem`,
				width: '100%',
			};
		},
		singleWorkoutStyle: () => {
			let minHeight = `60vh`;
			let minWidth = '35%';
			if (size === 'xl') {
				minHeight = `50vh`;
				minWidth = `18vw`;
			}
			if (size === 'lg') {
				console.log('large');
				minHeight = `50vh`;
				minWidth = `18vw`;
			} else if (size === 'md') {
			} else if (size === 'sm') {
			}
			if (isMobile) {
				minHeight = 'inherit';
				minWidth = 'inherit';
			}

			return {
				height: isMobile ? `20rem` : `auto`,
				margin: `0rem ${isMobile ? 'auto' : '0rem'}`,
				width: isMobile ? '15rem' : 'inherit',
				maxWidth: '100%',
				minHeight: minHeight,
				minWidth: minWidth,
			};
		},
		singleWorkoutClasses: () => {
			let classes = 'mt-3';
			isMobile ? (classes += ' col-12') : '';
			return classes;
		},
		downloadPannelStyle: () => {
			return {
				diplay: 'flex',
				flexDirection: 'column',
				padding: '0rem 1rem 1rem 0rem',
				backgroundColor: 'rgba(255, 255, 255, 0.5)',
				borderRadius: '10px',
				border: `2px solid rgba(0, 0, 0, 0.5)`,
				marginTop: '1rem',
				widht: '100%',
				height: `auto`,
				marginLeft: '1rem',
			};
		},
		downloadPannelClasses: () => {
			let classes = 'my-sm-auto';
			isMobile ? (classes += ' col-12') : '';
			return classes;
		},
		downloadMetaContainerStyle: () => {
			return {display: `flex`, flexWrap: 'wrap'};
		},
		outlinerStyle: () => {
			return {
				margin: '1rem 0rem 0rem 1rem',
				border: `2px solid rgba(0, 0, 0, 0.5)`,
				borderRadius: '10px',
			};
		},
		outlinerText: () => {
			return {
				padding: '0.5rem',
			};
		},
		buttonsContainerStyle: () => {
			return {
				display: 'flex',
				flexWrap: 'wrap',
			};
		},
		buttonStyle: () => {
			return {
				padding: `0.5rem 2rem`,
				height: 'auto',
				width: 'auto',
				margin: '1rem 0rem 0rem 1rem',
			};
		},
	};
}

export default Styles;
